import axios from "axios";

export const fetchAgoraToken = async (basUrl, channel, type = "audio", receiverId = "") => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${basUrl}call/token`,
    { channel, type, receiver_id: receiverId },
    token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
  );

  if (response.data?.Result !== "true") {
    throw new Error(response.data?.ResponseMsg || "Unable to generate Agora token.");
  }

  return {
    appId: response.data.agora_app_id,
    token: response.data.token,
    channel: response.data.channel || channel,
    uid: Number(response.data.uid || 0),
  };
};
